import { useMemo } from 'react'

import { form } from '../../formState'
import { useTexts } from './useTexts'

export function Type() {
  const texts = useTexts()

  const options = useMemo(
    () => [
      {
        label: texts.disabled,
        value: 'disabled',
      },
      {
        label: texts.blocked,
        value: 'blocked',
      },
      {
        label: texts.delayed,
        extraLabel: texts.min,
        value: 'delayed',
      },
    ],
    [texts],
  )

  return (
    <form.RadioGroup name="type" label={texts.label} options={options} testId="road-editor-type" />
  )
}
